<template>
  <div class="ctn">
    <main-menu-line :arrow="false" icon="el-icon-user" @click="loginHandler">Login</main-menu-line>
    <main-menu-line shortcut="Alt + N" :arrow="false" icon="el-icon-news" @click="newSessionHandler">New Session</main-menu-line>
    <main-menu-line shortcut="Alt + O" :arrow="false" icon="el-icon-copy-document" @click="showSessionListHandler">Sessions</main-menu-line>
    <main-menu-line shortcut="" :arrow="false" icon="el-icon-upload2" @click="importSessionsHandler">Import Sessions</main-menu-line>
    <main-menu-line shortcut="" :arrow="false" icon="el-icon-download" @click="exportSessionsHandler">Export Sessions</main-menu-line>
    <divider />
    <main-menu-line :arrow="false" icon="el-icon-key" @click="showKeystHandler">Keys Manager</main-menu-line>
    <main-menu-line :arrow="false" icon="el-icon-s-platform" @click="showSshKnownHostsHandler">SSH Known Hosts</main-menu-line>
    <divider />
    <main-menu-line shortcut="Alt + G" :arrow="false" icon="el-icon-guide" @click="showGuideHandler">Guide</main-menu-line>
    <divider />
    <main-menu-line shortcut="" :arrow="false" icon="el-icon-printer" @click="printOutputHandler">Print Output</main-menu-line>
    <main-menu-line shortcut="" :arrow="false" icon="el-icon-document-copy" @click="exportOutputHandler">Export Output</main-menu-line>
    <divider />
    <main-menu-line shortcut="" :arrow="false" icon="el-icon-s-tools" @click="showOptionsHandler">Options</main-menu-line>
    <main-menu-line shortcut="" :arrow="false" icon="el-icon-info" @click="aboutHandler">About Waterfall</main-menu-line>
  </div>
</template>

<script>
import Divider from '../common/divider.vue'
import mainMenuLine from './mainMenuLine.vue'
export default {
  components: { mainMenuLine, Divider },
  name: "mainMenu",
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    show() {
      let self = this
      this.visible = true
      document.addEventListener("click", () => { self.hide() }, {once: true})
    },
    hide() {
      this.visible = false
    },
    loginHandler() {
      this.env.ui.showLogin()
      // this.env.hideTabsTopMenu()
    },
    newSessionHandler() {
      this.env.hideTabsTopMenu()
      this.$emit("addNewSess")
    },
    showSessionListHandler() {
      this.env.showSessionList()
      this.env.hideTabsTopMenu()
    },
    importSessionsHandler() {
      this.env.hideTabsTopMenu()
      this.env.ui.showImportSession()
    },
    exportSessionsHandler() {
      this.env.hideTabsTopMenu()
      this.utils.sess.exportAllSession(this)
    },
    showKeystHandler() {
      this.env.ui.showKeys()
      this.env.hideTabsTopMenu()
    },
    showSshKnownHostsHandler() {
      this.env.ui.showSshKnownHosts()
      this.env.hideTabsTopMenu()
    },
    exportOutputHandler() {
      this.env.term.exportCurLog()
      this.env.hideTabsTopMenu()
    },
    printOutputHandler() {
      this.env.term.printCurLog()
      this.env.hideTabsTopMenu()
    },
    showGuideHandler() {
      this.env.ui.showGuide()
      this.env.hideTabsTopMenu()
    },
    showOptionsHandler() {
      this.env.hideTabsTopMenu()
      this.env.ui.showOptions()
    },
    aboutHandler() {
      this.env.hideTabsTopMenu()
      this.env.ui.showAbout()
    },
  },
}
</script>

<style scoped>
.ctn {
  width: 260px;
  max-height: 90vh;

  font-size: 14px;
  color: #c4c4c4;
  background: #3c3c3c;
  border-radius: 3px;
}
</style>